import { $wallpaperConfig } from '@client/core/atoms/wallpaperConfigAtom';
import {
  fetchAllElements,
  fetchElement,
  styleElements
} from '@client/core/utils/dom/domUtils';

// we have to undo the stuff again after in case of ads refresh without page refresh
export const initiateHandleWallpaper = () => {
  $wallpaperConfig.subscribe((config, prevConfig) => {
    // skyscrapers
    const stickyElements = fetchAllElements('.banners__skyscraper');
    styleElements(stickyElements, {
      position: config.stickySkyscrapers ? 'sticky' : 'static'
    });

    const clickEvent = (event) => {
      if (event.defaultPrevented) return;
      window.open(config.clickThroughUrl, '_blank');
    };

    // image
    if (config.wallpaperImage) {
      const { body } = document;
      body.style.pointerEvents = 'none';
      const wallpaperDiv = document.createElement('div');
      wallpaperDiv.id = 'advt-wallpaper-container';
      wallpaperDiv.style.zIndex = '-1';
      wallpaperDiv.style.pointerEvents = 'all';
      const mainContents = fetchAllElements(
        'main, finn-footer, finn-topbar, .page-container'
      );
      mainContents.forEach((content) => {
        content.style.pointerEvents = 'all';
      });
      // Insert wallpaperDiv after the top of the body
      document.body.insertBefore(wallpaperDiv, document.body.firstChild);

      if (wallpaperDiv) {
        if (config.clickThroughUrl) {
          wallpaperDiv.style.cursor = 'pointer';
          wallpaperDiv.addEventListener('click', clickEvent);
        } else {
          wallpaperDiv.style.cursor = 'default';
          wallpaperDiv.removeEventListener('click', clickEvent);
        }

        wallpaperDiv.style.backgroundImage = `url(${config.wallpaperImage})`;
        wallpaperDiv.style.backgroundPosition = 'center top';
        wallpaperDiv.style.height = config.stickyWallpaper ? '100vh' : '1080px';
      }
    } else if (prevConfig?.wallpaperImage && !config.wallpaperImage) {
      const wallpaperDiv = fetchElement(
        "advt-component[placementid='advt_wallpaper'] .advt-placement-container"
      );
      if (wallpaperDiv) wallpaperDiv.style.backgroundImage = 'unset';
    }
  });
};
